/**
 * S60.1 hotfix #4 — create/edit/publish-now/retry always returned HTTP 200
 * with per-network results embedded in the body, but the composer/history
 * showed a blanket "success" toast without ever reading that body. A post
 * where every network came back 'not_connected'/'failed' looked identical
 * to one that actually went out. Centralizes reading `status`/`results` so
 * every call site shows what really happened.
 */
export function describePublishOutcome(post) {
  const results = post?.results || {};
  const entries = Object.entries(results);
  const failures = entries
    .filter(([, r]) => r.status !== 'published')
    .map(([net, r]) => `${net}: ${r.error || r.status}`);

  if (post?.status === 'published') {
    return { level: 'success', message: 'Publicado con éxito' };
  }
  if (post?.status === 'scheduled') {
    return { level: 'success', message: 'Publicación programada' };
  }
  if (post?.status === 'partial') {
    return { level: 'warning', message: `Se publicó parcialmente — revisa: ${failures.join(' · ')}` };
  }
  if (post?.status === 'failed') {
    return { level: 'error', message: failures.length ? `No se publicó en ninguna red — ${failures.join(' · ')}` : 'No se pudo publicar' };
  }
  return { level: 'success', message: 'Guardado' };
}

export function toastPublishOutcome(toast, post) {
  const { level, message } = describePublishOutcome(post);
  if (level === 'success') toast.success(message);
  else if (level === 'warning') toast.warning(message);
  else toast.error(message);
}
